"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
/**
 * Write a {@link Conjunction} update constraint to the stream
 */
function write(bos, value, writer) {
    Codec.writeCollection(bos, value.getConstraints(), writer);
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/conjunction-serialiser.js
// module id = 1482
// module chunks = 0